var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from "react";
import EdModal from "@frameworks/shared-library/components/edModal";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import CustomCalendarHeader from "@frameworks/shared-library/components/MandateCalendar/CustomCalendarHeader/CustomCalendarHeader";
import "@frameworks/shared-library/stylesheets/components/MandateCalendar/MandateCalendar.scss";
import summarize from "@domains/utils/summarize";
export var todaysDate = new Date(new Date().setDate(new Date().getDate()));
var MandateCalendar = function (props) {
    var _a = props.leftIcon, leftIcon = _a === void 0 ? "edel-icon-calendar-rounded-1" : _a, _b = props.rightIcon, rightIcon = _b === void 0 ? "edel-icon-bold-close" : _b, _c = props.subtitle, subtitle = _c === void 0 ? "Check the available amount in your mandate calendar" : _c, _d = props.title, title = _d === void 0 ? "Mandate Calendar" : _d, _e = props.toggleMandateCalendar, toggleMandateCalendar = _e === void 0 ? null : _e, _f = props.isMandateCalendarShow, isMandateCalendarShow = _f === void 0 ? true : _f, dateAmountDict = props.dateAmountDict, triggerGetCalendarData = props.triggerGetCalendarData;
    var _g = __read(useState(true), 2), isShowCalendarPopUp = _g[0], setShowCalendarPopUp = _g[1];
    var _h = __read(useState(todaysDate), 2), selectedDate = _h[0], setSelectedDate = _h[1];
    var _j = __read(useState(new Date()), 2), visibleMonth = _j[0], setVisibleMonth = _j[1];
    var renderDayContents = function (date) {
        var momentDate = moment(date);
        var isCurrentMonth = (date === null || date === void 0 ? void 0 : date.getMonth()) === visibleMonth.getMonth() &&
            (date === null || date === void 0 ? void 0 : date.getFullYear()) === visibleMonth.getFullYear();
        var startDate = momentDate.isValid()
            ? momentDate.format("DD MMM YYYY")
            : "";
        var displayDate = momentDate.isValid()
            ? momentDate.date().toString()
            : "";
        var totalAmount = undefined;
        var formattedAmount = undefined;
        if (dateAmountDict === null || dateAmountDict === void 0 ? void 0 : dateAmountDict.get(startDate)) {
            totalAmount = dateAmountDict.get(startDate);
            formattedAmount = summarize(totalAmount);
        }
        return (React.createElement("div", null,
            displayDate,
            React.createElement("div", { className: "RobotoM_12_500 selected_date_styles ".concat(Number(totalAmount) > 1000 ? "txt_green" : "txt_salmon") }, isCurrentMonth ? (Number(totalAmount) > 0 ? (React.createElement(React.Fragment, null,
                "\u20B9 ",
                formattedAmount)) : ("₹ 0")) : (""))));
    };
    var handleMonthChange = function (date) {
        setVisibleMonth(date);
        var changedDate = moment(date)
            .startOf("month")
            .format("DD MMM YYYY");
        triggerGetCalendarData(changedDate);
    };
    var mandateHeader = useCallback(function () {
        return (React.createElement(CustomCalendarHeader, { setShow: setShowCalendarPopUp, title: title, subtitle: subtitle, icon: "edel-icon-calendar-rounded-1", closeDropdown: setShowCalendarPopUp, rightSideIcon: "".concat(rightIcon, " edel-btn-right"), leftSideIcon: "left_side_icon", isMandateCalendarShow: isMandateCalendarShow }));
    }, [rightIcon]);
    var modalChild = function () {
        return (React.createElement("div", { className: "mgt-20  mandate-datepicker-container ".concat(!isMandateCalendarShow ? "mb-0" : "", " ") },
            toggleMandateCalendar && (React.createElement("div", { onClick: function () { return toggleMandateCalendar(); } }, mandateHeader())),
            isMandateCalendarShow && (React.createElement(ReactDatePicker, { inline: true, selected: selectedDate, placeholderText: "dd-mm-yy", dateFormat: "dd-MMM-yy", minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 100)), 
                // maxDate={new Date()}
                formatWeekDay: function (nameOfDay) { return nameOfDay.slice(0, 3); }, scrollableYearDropdown: true, scrollableMonthYearDropdown: true, onChange: function (date) { return setSelectedDate(date); }, renderDayContents: function (dayOfMonth, date) {
                    return renderDayContents(date);
                }, onMonthChange: function (date) { return handleMonthChange(date); } }))));
    };
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.setShowMandateCalendar) {
            props === null || props === void 0 ? void 0 : props.setShowMandateCalendar(isShowCalendarPopUp);
        }
    }, [isShowCalendarPopUp]);
    return (React.createElement("div", { className: "primary_calendar_mandate_container ".concat(toggleMandateCalendar ? "primary_calendar_mandate_sidebar" : "") }, toggleMandateCalendar ? (React.createElement(React.Fragment, null, modalChild())) : (React.createElement(EdModal, { show: isShowCalendarPopUp, setShow: setShowCalendarPopUp, closeDropdown: setShowCalendarPopUp, modalTitle: "modalHoldingTitle", title: title, showFooter: false, icon: leftIcon, customModalHeader: mandateHeader() },
        React.createElement(React.Fragment, null, modalChild())))));
};
export default MandateCalendar;
